import axios from 'axios';
import API_CONFIG from '../config/api';

const api = axios.create(API_CONFIG);

// Add a request interceptor
api.interceptors.request.use(
    (config) => {
        // Get the token from localStorage
        const token = localStorage.getItem('token');
        
        // If token exists, add it to the headers
        if (token) {
            config.headers['X-Authorization'] = `Bearer ${token}`;
        }
        
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

// override methods to use POST with X-HTTP-Method-Override header
api.interceptors.request.use(config => {
    const overrideMethods = ['PUT', 'DELETE'];
  
    if (overrideMethods.includes(config.method.toUpperCase())) {
      // Add override header
      config.headers['X-HTTP-Method-Override'] = config.method.toUpperCase();
      
      // Change actual HTTP method to POST
      config.method = 'post';
    }
  
    return config;
  }, error => {
    return Promise.reject(error);
  });

// Add a response interceptor

api.interceptors.response.use(
    (response) => response,
    (error) => {
        // Handle 401 Unauthorized errors
        if (error.response && error.response.status === 401) {
            // Clear local storage
            localStorage.removeItem('token');
            localStorage.removeItem('user');
            
            // Only redirect if not already on login page
            if (!window.location.pathname.includes('/#login')) {
                window.location.href = '/#login';
            }
        }
        
        return Promise.reject(error);
    }
);

export default api; 